import React from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Button, Grid, TextField } from "@mui/material";

import AppForm from "components/Shared/AppForm";
import BaseSelect from "components/Shared/Base/BaseSelect";
import AppSwitch from "components/Shared/AppSwitch";

import { ACCOUNT_TYPES } from "data/static/staticOptions";

const INITIAL_STATE = {
  name: "",
  displayName: "",
  email: "",
  contactNumber: "",
  domain: "",
  type: "System",
  isActive: true,
};

const AccountForm = ({
  isBusy = false,
  accountDetail = null,
  onSubmit = () => {},
}) => {
  const navigate = useNavigate();

  // react form hook
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: INITIAL_STATE,
  });

  // methods
  const handleOnAccountSubmit = (data) => {
    onSubmit(data);
  };

  React.useEffect(() => {
    if (!accountDetail) return;
    reset({ ...accountDetail });
  }, [accountDetail, reset]);

  return (
    <AppForm loading={isBusy}>
      <AppForm.Content>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Please provide a Name." }}
              render={({ field }) => (
                <TextField
                  {...field}
                  required
                  fullWidth
                  size="small"
                  label="Name"
                  error={!!errors.name}
                  helperText={errors?.name?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="displayName"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  size="small"
                  label="Display Name"
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  size="small"
                  label="Email"
                  type="email"
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="contactNumber"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  size="small"
                  label="Contact Number"
                  type="tel"
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="domain"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  size="small"
                  label="Domain"
                  type="email"
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="type"
              control={control}
              render={({ field }) => (
                <BaseSelect
                  {...field}
                  fullWidth
                  label="Type"
                  options={ACCOUNT_TYPES}
                />
              )}
            />
          </Grid>

          <Grid item xs={6}>
            <Controller
              name="isActive"
              control={control}
              render={({ field }) => (
                <AppSwitch {...field} label="Is Active?" />
              )}
            />
          </Grid>
        </Grid>
      </AppForm.Content>

      <AppForm.Actions>
        <Button onClick={() => navigate(-1)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={handleSubmit(handleOnAccountSubmit)}
        >
          {accountDetail ? "Update" : "Add"}
        </Button>
      </AppForm.Actions>
    </AppForm>
  );
};

export default AccountForm;
